export enum ConstructionStatus {
  RegistrationStarted = "RegistrationStarted",
  Registered = "Registered",
  Accepted = "Accepted",
  Deleted = "Deleted",
}

export default ConstructionStatus;
